export default {"src":"/_next/static/media/outlined_diji.2b82212c.svg","height":422,"width":1702};